//Imports
import React, { useContext, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { db } from "../../../firebase";
import { addDoc, collection, doc, updateDoc } from "firebase/firestore";
//Import Context 
import { AppContext } from "../../../contexts/AppContext";
//Imports Components
import FormEditProject from "./FormEditProject";
import FormEditEstablishment from "./FormEditEstablishments";
import MessageConfirmation from "../../messageConfirmation/MessageConfirmation";
//Imports Icons
import save from '../../../assets/icons/saveIcon.svg';
//Imports CSS
import './addProjectForm.css';
import 'react-datepicker/dist/react-datepicker.css';
import { AuthContext } from "../../../contexts/AuthContext";

function EditProjectForm() {
    const { dataProjects, isLoading, establishmentList } = useContext(AppContext);
    const { userData } = useContext(AuthContext);
    const { id } = useParams();
    const navigate = useNavigate();

    const currentProject = dataProjects.filter(project => project.id === id)[0];
    const currentProjectEstablishments = establishmentList.filter(establishment => establishment.projectId === id);

    const [nameProject, setNameProject] = useState(currentProject ? currentProject.nameProject : '');
    const [selectRegionProject, setSelectRegionProject] = useState(currentProject ? currentProject.region : '');
    const [selectCommuneProject, setSelectCommuneProject] = useState(currentProject ? currentProject.commune : '');
    const [selectDependencies, setSelectDependencies] = useState(currentProject ? currentProject.dependencie : '');
    const [dateFrom, setDateFrom] = useState(currentProject ? new Date(currentProject.contractValidity[0].dateFrom) : null);
    const [dateUntil, setDateUntil] = useState(currentProject ? new Date(currentProject.contractValidity[0].dateUntil) : null);
    const [selectRegionEstablishment, setSelectRegionEstablishment] = useState('');
    const [establishments, setEstablishments] = useState(currentProjectEstablishments && currentProjectEstablishments);
    const [messageConfirmation, setMessageConfirmation] = useState(false);
    const [messageError, setMessageError] = useState(false);

    const isAdmin = userData?.permissions === 'admin';
    const isSostenedor = userData?.dimension === 'Sostenedor';

    // Disable fields if not admin or sostenedor
    const isFormDisabled = !isAdmin && isSostenedor;

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const dateFromTimestamp = dateFrom ? dateFrom.getTime() : null;
            const dateUntilTimestamp = dateUntil ? dateUntil.getTime() : null;
            // 1. Prepare the updated data
            const updatedProjectData = {
                nameProject: nameProject,
                region: selectRegionProject,
                commune: selectCommuneProject,
                dependencie: selectDependencies,
                contractValidity: [
                    {
                        dateFrom: dateFromTimestamp,
                        dateUntil: dateUntilTimestamp,
                    }
                ],
            };
            // 2. Update the Project Document (if necessary)
            const projectRef = doc(db, 'projects', id);
            const projectFieldsToUpdate = {};
            Object.keys(updatedProjectData).forEach(key => {
                if (updatedProjectData[key] !== currentProject[key]) {
                    projectFieldsToUpdate[key] = updatedProjectData[key];
                }
            });

            if (Object.keys(projectFieldsToUpdate).length > 0) {
                await updateDoc(projectRef, projectFieldsToUpdate);
            }

            // 3. Update or Add Establishments Documents
            for (let i = 0; i < establishments.length; i++) {
                const establishment = establishments[i];

                // Check if the establishment exists in the current project
                const existingEstablishmentIndex = currentProjectEstablishments.findIndex(
                    (existingEstablishment) => existingEstablishment.id === establishment.id
                );

                if (existingEstablishmentIndex !== -1) {
                    // Update existing establishment
                    const establishmentRef = doc(db, 'establishments', establishment.id);

                    // Check if any establishment fields have changed
                    const establishmentFieldsToUpdate = {};
                    Object.keys(establishment).forEach(key => {
                        if (establishment[key] !== currentProjectEstablishments[i][key]) {
                            establishmentFieldsToUpdate[key] = establishment[key];
                        }
                    });

                    // Update the establishment document (if necessary)
                    if (Object.keys(establishmentFieldsToUpdate).length > 0) {
                        await updateDoc(establishmentRef, establishmentFieldsToUpdate);
                    }
                } else {
                    // Add new establishment
                    const establishmentUUID = uuidv4();
                    const newEstablishment = {
                        projectId: id, // Associate with the current project
                        rbd: establishment.rbd,
                        nameEstablishment: establishment.nameEstablishment,
                        uid: establishmentUUID,
                        region: establishment.region,
                        commune: establishment.commune,
                        typeEstablishment: establishment.typeEstablishment,
                    };

                    const establishmentRef = await addDoc(collection(db, 'establishments'), newEstablishment);
                    console.log('New establishment added:', establishmentRef.id);
                }
            }
            // 4. Handle Success
            console.log('Project and establishments updated successfully!');
            sessionStorage.setItem('projectAdded', 'true');
            setMessageConfirmation(true);
            navigate(-1);

        } catch (error) {
            // 5. Handle Errors
            setMessageError(true);
            setTimeout(() => {
                setMessageError(false);
            }, 3000);
            console.error('Error updating project or establishments:', error);
        }
    };

    return (
        <>
            <section className='container-add-projec-form flex'>
                <p>Editar Proyecto: <span className='name-project' >{!isLoading && currentProject.nameProject}</span></p>
                <form className='container-form flex' onSubmit={handleSubmit}>
                    {
                        (dataProjects && !isLoading) ?
                            (<>
                                <FormEditProject
                                    nameProject={nameProject}
                                    setNameProject={setNameProject}
                                    selectRegionProject={selectRegionProject}
                                    setSelectRegionProject={setSelectRegionProject}
                                    selectCommuneProject={selectCommuneProject}
                                    setSelectCommuneProject={setSelectCommuneProject}
                                    selectDependencies={selectDependencies}
                                    setSelectDependencies={setSelectDependencies}
                                    dateFrom={dateFrom}
                                    setDateFrom={setDateFrom}
                                    dateUntil={dateUntil}
                                    setDateUntil={setDateUntil}
                                    disabled={isFormDisabled}
                                />
                                <FormEditEstablishment
                                    selectRegionEstablishment={selectRegionEstablishment}
                                    setSelectRegionEstablishment={setSelectRegionEstablishment}
                                    establishments={establishments}
                                    setEstablishments={setEstablishments}
                                />
                            </>) :
                            (<p>Loading...</p>)
                    }
                    <article className='box-actions flex'>
                        <button type='submit' className='save-project-button flex'>
                            <img src={save} className='icon' alt='Icono para editar proyecto' />
                            <p>Editar Proyecto</p>
                        </button>
                        <Link to='/proyectos' className='cancel'><p>Cancelar</p></Link>
                    </article>
                </form>
                {
                    (messageConfirmation || messageError) && (<MessageConfirmation confirmation={messageConfirmation} error={messageError} />)
                }
            </section>
        </>
    )
};

export default EditProjectForm;